export default __webpack_public_path__ + "2bd7e6580bcb69e1d3ff0d2b36a0bf66.png";